// Microcopy centralizado para o fluxo de onboarding

export const onboardingCopy = {
  welcome: {
    title: "Inteligência que facilita a vida de quem cuida.",
    subtitle: "A Elinia transforma dados clínicos em decisões mais seguras e eficientes.",
    description: "Envie exames, relatórios e imagens. Nossa IA organiza e revela o que importa.",
    primaryButton: "Começar agora",
    preparingMessage: "Preparando seu espaço seguro na plataforma…"
  },
  register: {
    title: "Cadastro do profissional",
    fields: {
      name: {
        label: "Nome completo",
        placeholder: "Digite seu nome como deseja aparecer na plataforma."
      },
      cpf: {
        label: "CPF",
        placeholder: "Somente números"
      },
      email: {
        label: "E-mail",
        placeholder: "Seu e-mail profissional"
      },
      password: {
        label: "Senha",
        placeholder: "Crie uma senha segura (mínimo 8 caracteres)"
      },
      healthArea: {
        label: "Área da Saúde",
        placeholder: "Selecione sua especialidade"
      }
    },
    success: "Conta criada com sucesso! 🎉 Você já pode começar a usar a plataforma.",
    errors: {
      cpf: "CPF inválido. Verifique o formato.",
      email: "Por favor, insira um e-mail válido.",
      password: "A senha deve ter pelo menos 8 caracteres.",
      fillAll: "Preencha todos os campos antes de continuar."
    }
  },
  confirm: {
    title: "Confirme seu e-mail",
    description: "Enviamos um link de confirmação para {{email}}. Clique nele para ativar sua conta.",
    resendButton: "Reenviar e-mail",
    spamNote: "Não recebeu? Verifique a pasta de spam.",
    resendSuccess: "E-mail reenviado! Verifique sua caixa de entrada 📬"
  },
  patient: {
    title: "Cadastre seu primeiro paciente",
    subtitle: "Crie o repositório para iniciar as análises.",
    fields: {
      name: {
        label: "Nome completo",
        placeholder: "Nome completo do paciente"
      },
      cpf: {
        label: "CPF",
        placeholder: "Somente números"
      }
    },
    button: "Avançar para o envio de exames",
    success: "Paciente cadastrado com sucesso.",
    errors: {
      fillAll: "Preencha todos os campos antes de continuar.",
      cpf: "CPF inválido. Verifique o formato."
    }
  },
  upload: {
    title: "Envie os exames do seu paciente",
    description: "Arraste os arquivos ou clique para selecionar. Aceitamos PDF, imagem e planilha.",
    uploading: "Enviando arquivo…",
    processing: "Processando dados…",
    analyzing: "Analisando conteúdo do documento…",
    success: "Tudo certo! Exame enviado e processado com sucesso 🎉",
    error: "Não conseguimos processar este arquivo. Tente novamente ou envie em outro formato.",
    tip: "Você pode adicionar novos exames do mesmo paciente a qualquer momento.",
    continueButton: "Continuar"
  },
  analysis: {
    title: "Gerando insights sobre seu paciente…",
    description: "A Elinia está organizando e interpretando os dados enviados.",
    placeholder: "Identificando resultados, tendências e possíveis riscos...",
    question: "O que você gostaria de ver primeiro?",
    options: {
      evolution: "📈 Evolução dos principais exames",
      risks: "⚠️ Possíveis riscos e alertas",
      suggestions: "💬 Sugestões de acompanhamento"
    },
    finalButton: "Ver resultado completo",
    success: "Análise concluída! Seu primeiro insight está pronto 🚀"
  },
  general: {
    loading: "Só mais um instante…",
    error: "Algo deu errado. Tente novamente em instantes.",
    success: "Tudo pronto!",
    saving: "Salvando suas informações…",
    goodbye: "Até logo! Continue de onde parou quando quiser.",
    lgpd: "Seus dados são protegidos conforme a LGPD."
  }
};

export const healthAreas = [
  { value: "medicina", label: "Medicina" },
  { value: "nutricao", label: "Nutrição" },
  { value: "fisioterapia", label: "Fisioterapia" },
  { value: "psicologia", label: "Psicologia" },
  { value: "educacao-fisica", label: "Educação Física" },
  { value: "quiropraxia", label: "Quiropraxia" },
  { value: "estetica", label: "Estética" }
];
